module.exports = __webpack_public_path__ + "assets/img/3r.277ce7b8.png";